import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { ImportacaoRascunhos } from "@interfaces/cnpj-lookup";
import { Ncm } from "@interfaces/ncm";
import { Store } from "@ngrx/store";
import { UserActions } from "@state/actions/user.actions";
import { selectToken } from "@state/selectors/user.selectors";
import { tap } from "rxjs";
import { HttpService } from "./http.service";

@Injectable({
  providedIn: "root"
})
export class NcmService {
  private readonly token = this.store.selectSignal(selectToken);

  constructor(
    private httpService: HttpService,
    private store: Store
  ) {}

  save(payload: unknown) {
    return this.httpService
      .post(
        `${environment.api.mv.nf}/ncm`,
        payload,
        new HttpHeaders({
          Authorization: `Bearer ${this.token()}`
        })
      )
      .pipe(
        tap(() =>
          this.store.dispatch(
            UserActions.loadToken({
              token: this.token()
            })
          )
        )
      );
  }

  /**
   * Importa NCMs sugeridos pelo CNAE como rascunho (só o código, sem
   * tributos). O `loadToken` recarrega a empresa e a lista de NCMs.
   */
  importar(ncms: string[]) {
    return this.httpService
      .post<ImportacaoRascunhos<Ncm>>(
        `${environment.api.mv.nf}/ncm/importar`,
        { ncms },
        new HttpHeaders({
          Authorization: `Bearer ${this.token()}`
        })
      )
      .pipe(
        tap(() =>
          this.store.dispatch(
            UserActions.loadToken({
              token: this.token()
            })
          )
        )
      );
  }

  delete(id: string) {
    return this.httpService
      .del(
        `${environment.api.mv.nf}/ncm/${id}`,
        new HttpHeaders({
          Authorization: `Bearer ${this.token()}`
        })
      )
      .pipe(
        tap(() =>
          this.store.dispatch(
            UserActions.loadToken({
              token: this.token()
            })
          )
        )
      );
  }
}
